var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('h1',{staticClass:"subtitle-2 text--primary mb-2"},[_vm._t("title")],2),_c('v-divider'),_c('div',{staticClass:"body-2 mt-2"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }